var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 20,
    height: 20,
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(19032 9796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 24,
    height: 24,
    transform: "translate(-19032 -9796)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-settings",
    transform: "translate(-19030 -9794)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M11.333,8a3.333,3.333,0,1,0,2.357.976A3.333,3.333,0,0,0,11.333,8Zm0,5a1.667,1.667,0,1,1,1.178-.488A1.666,1.666,0,0,1,11.333,13Z",
    transform: "translate(-1.333 -1.333)",
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M17.946,11.583l-.37-.213a7.583,7.583,0,0,0,0-2.742l.37-.213a2.5,2.5,0,0,0-2.5-4.333l-.371.214A7.48,7.48,0,0,0,12.7,2.928V2.5a2.5,2.5,0,1,0-5,0v.428A7.481,7.481,0,0,0,5.327,4.3l-.372-.216a2.5,2.5,0,0,0-2.5,4.333l.37.213a7.583,7.583,0,0,0,0,2.742l-.37.213a2.5,2.5,0,0,0,2.5,4.333l.371-.214A7.48,7.48,0,0,0,7.7,17.072V17.5a2.5,2.5,0,1,0,5,0v-.428A7.48,7.48,0,0,0,15.074,15.7l.373.215a2.5,2.5,0,1,0,2.5-4.333ZM15.822,8.437a5.872,5.872,0,0,1,0,3.125.834.834,0,0,0,.387.944l.9.522a.834.834,0,1,1-.833,1.444l-.9-.523a.833.833,0,0,0-1.012.137,5.819,5.819,0,0,1-2.7,1.563.833.833,0,0,0-.626.808V17.5a.833.833,0,0,1-1.667,0V16.457a.833.833,0,0,0-.626-.807,5.82,5.82,0,0,1-2.7-1.566.833.833,0,0,0-1.012-.137l-.9.522a.833.833,0,1,1-.833-1.443l.9-.522a.833.833,0,0,0,.387-.944,5.873,5.873,0,0,1,0-3.125.833.833,0,0,0-.388-.941l-.9-.522a.834.834,0,0,1,.833-1.444l.9.523a.833.833,0,0,0,1.012-.134,5.82,5.82,0,0,1,2.7-1.562.833.833,0,0,0,.626-.811V2.5a.833.833,0,0,1,1.667,0V3.543a.833.833,0,0,0,.626.808,5.82,5.82,0,0,1,2.7,1.566.833.833,0,0,0,1.012.137l.9-.522a.833.833,0,1,1,.833,1.443l-.9.522a.834.834,0,0,0-.386.941Z",
    transform: "translate(-0.201 0)",
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFooter);
export default __webpack_public_path__ + "static/media/SettingsFooter.7d539f407f090c55bbffc03dd97a3b0b.svg";
export { ForwardRef as ReactComponent };